<template>
    <v-col class="px-0 py-0" lg="12">
        <v-container fluid class="px-0 py-0 mb-0 " style="background: #FFFFFF !important;">
            <v-row align="center" justify="center">
                <v-col cols="12" sm="8" lg="8" xl="8" class="py-0 pl-0">
                    <div class="align-center pl-0 pl-md-5 py-lg-12 py-0">
                        <!-- Categoria -->
                        <!--<h3 class="mb-4 mb-md-0 titulo categoria">
                            {{ proyecto.fields.nombre }}
                        </h3>-->

                        <!-- Eslogan -->
                        <v-card flat :rounded="false" width="100%">
                            <v-card-text>
                                <small class="d-block d-lg-none">{{ tipoProyecto.fields.nombre }}</small>
                                <h1 v-if="proyecto.fields.nombre" class="mb-0 mb-md-0 eslogan categoria">
                                    <b class="my-auto">
                                        {{ proyecto.fields.nombre }}
                                    </b>
                                </h1>
                            </v-card-text>
                            <v-img
                                :src="proyecto.fields.media_file[0].url"
                                v-if="proyecto.fields.media_file && proyecto.fields.media_file.length"
                                class="my-0 d-block d-lg-none"
                            />
                            <v-card-text>
                                <p class="mb-0">
                                    {{ proyecto.fields.descripcion }}
                                </p>
                            </v-card-text>
                        </v-card>
                        <!--<v-container fluid class="px-0 py-0">
                            <v-row align="center"
                                   justify="center">
                                <v-col cols="6" class="py-0">

                                </v-col>
                                <v-col cols="6" class="py-0">

                                </v-col>
                            </v-row>
                        </v-container>-->
                        <br />
                        <!--<p v-if="proyecto.fields.precio_final && presentacion.fields.precios && windowWidth > 992" class="mb-0 mt-0 mt-lg-5 mt-md-0 texto">
                            {{ formatPrice(proyecto.fields.precio_final) }}
                        </p>-->
                    </div>
                </v-col>
                <v-col cols="12" sm="4" lg="4" xl="4" class="px-0 py-0 d-none d-lg-block">
                    <!-- Imagen -->
                    <v-img :src="proyecto.fields.media_file[0].url" v-if="proyecto.fields.media_file && proyecto.fields.media_file.length" :aspect-ratio="16 / 9" />
                </v-col>
            </v-row>
        </v-container>
        <hr style="border: 1px solid #EBEBEB !important;" />
        <v-container fluid v-for="(tipoProducto, key) in tiposProductosFiltrados(proyecto.id)" :key="'tipoProducto' + key" class="my-0 my-lg-12">
            <v-row>
                <v-col cols="12">
                    <h2 class="text-center">{{ tipoProducto.fields.nombre }}</h2>
                </v-col>
            </v-row>
            <v-row class="justify-center">
                <v-col cols="6" md="6" lg="3" xl="2" v-for="(producto, key) in productosFiltrados(proyecto.id, tipoProducto.id)" :key="'producto' + key">
                    <v-img :src="producto.fields.media_url" v-if="producto.fields.media_url" class="mx-auto mw80" :aspect-ratio="16 / 9"  />
                    <h2 class="text-center my-3 nameProducto">{{producto.fields.nombre}}</h2>

                    <p class="text-center">
                        <small>
                            {{ conceptosFiltrados(proyecto.id, producto.id).map(concepto => concepto.fields.nombre).join(" | ") }}
                        </small>
                    </p>
                    <!--<v-list class="mt-5 my-0 py-0 mw80 mx-auto">
                        <v-list-item class="my-0 py-0" style="min-height: auto;" v-for="(concepto, key) in conceptosFiltrados(proyecto.id, producto.id)" :key="'concepto-' + key">
                            <v-list-item-content  class="my-0 py-0">
                                <v-list-item-title class="my-2 py-0" v-text="concepto.fields.nombre"></v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list>-->
                </v-col>
            </v-row>
            <hr style="border: 1px solid #EBEBEB !important;" v-if="tiposProductosFiltrados(proyecto.id).length - 1 !== key"/>
        </v-container>
        <Divider />
        <Divider up="true" />
    </v-col>
</template>

<style>

    @media(max-width: 991px) {
        .nameProducto {
            font-size: 120%;
        }
    }

    .mw80 {
        max-width: 70% !important;
    }

    @media(max-width: 992px) {
        .mw80 {
            max-width: 95% !important;
        }
    }

    .v-data-table th {
        user-select: text !important;
    }

    ::selection {
        background-color: #CCCCCC !important;
    }
</style>

<script>
import {mapState, mapGetters} from 'vuex';
import Divider from "@/components/Divider";
// import TipoProducto from "@/components/TipoProducto";
export default {
    name: "Proyecto",
    components: {Divider},
    props: {
        proyecto: {
            required: true,
            type: Object,
        },
        tipoProyecto: {
            required: true,
            type: Object,
        }
    },
    data() {
        return {
            show: false,
        }
    },
    computed: {
        ...mapState(['presentacion']),
        ...mapGetters(['tiposProductosFiltrados', 'productosFiltrados', 'conceptosFiltrados']),
        windowWidth() {
            return window.innerWidth;
        }
    }
}
</script>
